// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0e8cae33","455":"3d28c619","488":"59f8a129","977":"59707ddd"}[chunkId] + ".chunk.js";
};